import { render, staticRenderFns } from "./common-user-dialog.vue?vue&type=template&id=704b1135"
import script from "./common-user-dialog.vue?vue&type=script&lang=js"
export * from "./common-user-dialog.vue?vue&type=script&lang=js"
import style0 from "./common-user-dialog.vue?vue&type=style&index=0&id=704b1135&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports